import { render, staticRenderFns } from "./notificaciones.vue?vue&type=template&id=d24ef69c&scoped=true"
import script from "./notificaciones.vue?vue&type=script&lang=js"
export * from "./notificaciones.vue?vue&type=script&lang=js"
import style0 from "./notificaciones.vue?vue&type=style&index=0&id=d24ef69c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24ef69c",
  null
  
)

export default component.exports